module.exports = __webpack_public_path__ + "static/img/at.e2634e96.svg";